module.exports = __webpack_public_path__ + "static/media/capilano.08fc95b9.jpg";